module.exports = __webpack_public_path__ + "img/Guayaki.d8744ca2.png";